var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.element.options !== null &&
    _vm.element.options.attrs !== null &&
    _vm.show
    ? _c("el-tree-select", {
        ref: "deSelectTree",
        attrs: {
          "popover-class": "test-class-wrap",
          data: _vm.data,
          "select-params": _vm.selectParams,
          "tree-params": _vm.treeParams,
          "filter-node-method": _vm._filterFun,
          "tree-render-fun": _vm._renderFun,
          "custom-style": _vm.customStyle,
          "popper-append-to-body": _vm.inScreen,
        },
        on: {
          searchFun: _vm._searchFun,
          "node-click": _vm.changeNode,
          removeTag: _vm.changeNodeIds,
          check: _vm.changeCheckNode,
          "select-clear": _vm.selectClear,
          onFocus: _vm.onFocus,
          treeCheckChange: _vm.handleElTagStyle,
        },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }